var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.taskProgressShow,
          expression: "taskProgressShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "taskProgress" } }, [
        _c("div", {
          staticClass: "close-popup-other",
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        }),
        _vm._v(" "),
        !_vm.isVip()
          ? _c("div", { staticClass: "progress-title" }, [
              _c("div", { staticClass: "progress-title-1" }, [
                _vm._v(
                  "\r\n                " +
                    _vm._s(_vm.$t("language.cloudBackup.maximunBack")) +
                    "\r\n            "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "progress-title-2" }, [
                _vm._v(
                  "\r\n                " +
                    _vm._s(_vm.$t("language.popup.taskProgressPopup.title2")) +
                    "\r\n            "
                )
              ])
            ])
          : _c("div", { staticClass: "progress-title" }, [
              _c("div", { staticClass: "progress-title-1" }, [
                _vm._v(
                  "\r\n                " +
                    _vm._s(_vm.$t("language.popup.taskProgressPopup.title1")) +
                    "\r\n            "
                )
              ])
            ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "progress-list" },
          _vm._l(_vm.taskProgress, function(item) {
            return _c(
              "div",
              { key: item.id, staticClass: "progress-list-item" },
              [
                _c("div", [
                  _c("div", { staticClass: "small-file", class: item.icon })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "progres-item" },
                  [
                    _c("div", { staticClass: "progres-item-title" }, [
                      _c("div", { staticClass: "progres-name" }, [
                        _vm._v(
                          "\r\n                            " +
                            _vm._s(item.name) +
                            "\r\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "progres-percentage" }, [
                        !_vm.isVip()
                          ? _c("div", [
                              item.rate == -1
                                ? _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/task-icon/progress_lock.svg")
                                    }
                                  })
                                : _c("span", {}, [
                                    _vm._v(
                                      _vm._s(
                                        item.rate < 100 ? item.rate : 100
                                      ) + "%"
                                    )
                                  ])
                            ])
                          : _c("div", [
                              item.rate && item.rate >= 0
                                ? _c("span", {}, [
                                    _vm._v(
                                      _vm._s(
                                        item.rate < 100 ? item.rate : 100
                                      ) + "%"
                                    )
                                  ])
                                : _c("span", {}, [_vm._v("0%")])
                            ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.taskProgressShow && (item.rate != -1 || _vm.isVip())
                      ? _c("el-progress", {
                          attrs: {
                            percentage: item.rate >= 0 ? item.rate : 0,
                            color: "#5562B4",
                            "show-text": false,
                            "text-inside": true
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "progress-btns" }, [
          !_vm.isVip()
            ? _c("button", [
                _vm._v(
                  "\r\n                " +
                    _vm._s(_vm.$t("language.common.upgradeNow")) +
                    "\r\n                "
                ),
                _c("div", { staticClass: "progress-btn-tip" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.taskProgressPopup.btnTip"))
                  )
                ])
              ])
            : _c(
                "button",
                {
                  staticStyle: { background: "#3250c9" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [
                  _vm._v(
                    "\r\n                " +
                      _vm._s(_vm.$t("language.common.ok")) +
                      "\r\n            "
                  )
                ]
              )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17b4dd34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17b4dd34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/task_progress_popup.vue
// module id = null
// module chunks = 